import { render, staticRenderFns } from "./compBlastCard.vue?vue&type=template&id=109b0a31"
import script from "./compBlastCard.vue?vue&type=script&lang=js"
export * from "./compBlastCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports